module.exports = __webpack_public_path__ + "img/emoji_107.523ef7d6.png";